package com.hyperether.goodjob.repository.remote

import kotlinx.browser.window

actual object ApiConfig {
    actual val baseURL: String
        get() {
            return if (window.location.origin.contains("localhost")) {
                "http://localhost:3000" 
            } else {
                window.location.origin
            }
        }
}